// pages/Forum.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../api";
import { timeAgo, formatDate, formatDateTime, TimeAgo } from "../helpers/time";

export default function Forum() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading]       = useState(true);
    const [error, setError]           = useState(null);

    useEffect(() => {
        let cancelled = false;

        async function load() {
            try {
                const data = await apiFetch("/api/forum/categories");
                if (!cancelled) {
                    setCategories(data.categories);
                }
            } catch (err) {
                if (!cancelled) {
                    setError(err.message);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        load();
        return () => { cancelled = true; };
    }, []);

    // RENDER STATES

    if (loading) {
        return (
            <div className="wrapper card">
                <h1 className="card__title">Forum</h1>
                <div className="card__loading">Loading categories…</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="wrapper card">
                <h1 className="card__title">Forum</h1>
                <div className="card__error">
                    <p>Failed to load categories.</p>
                    <p className="card__error-detail">{error}</p>
                </div>
            </div>
        );
    }

    // MAIN RENDER

    return (
        <div className="wrapper card">
            <h1 className="card__title">Forum</h1>

            {categories.length === 0 ? (
                <p className="card__empty">No categories have been created yet.</p>
            ) : (
                <div className="card__list">
                    {/* Table header */}
                    <div className="card__row card__row--header">
                        <div className="card__col card__col--info">Category</div>
                        <div className="card__col card__col--stat">Threads</div>
                        <div className="card__col card__col--stat">Posts</div>
                        <div className="card__col card__col--activity">Last Activity</div>
                    </div>

                    {/* Category rows */}
                    {categories.map((cat) => (
                        <Link
                            key={cat.id}
                            to={`/forum/${cat.id}`}
                            className="card__row card__row--category"
                        >
                            <div className="card__col card__col--info">
                                <span className="card__name">
                                    {cat.name.toUpperCase()}
                                </span>
                                {cat.description && (
                                    <span className="card__desc">{cat.description}</span>
                                )}
                            </div>
                            <div className="card__col card__col--stat">
                                <span className="card__stat-number">{cat.thread_count}</span>
                                <span className="card__stat-label">
                                    thread{cat.thread_count !== 1 ? "s" : ""}
                                </span>
                            </div>
                            <div className="card__col card__col--stat">
                                <span className="card__stat-number">{cat.post_count}</span>
                                <span className="card__stat-label">
                                    post{cat.post_count !== 1 ? "s" : ""}
                                </span>
                            </div>
                            <div className="card__col card__col--activity">
                                <span className="card__activity-time">
                                    {timeAgo(cat.last_activity)}
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}